import { render, staticRenderFns } from "./HSCodeEdit.vue?vue&type=template&id=a3c19112&scoped=true"
import script from "./HSCodeEdit.vue?vue&type=script&lang=js"
export * from "./HSCodeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c19112",
  null
  
)

export default component.exports